import { ServiceCostType } from '~/models/service-cost';
export function formatPrice(price, pricingType) {
    if (pricingType === ServiceCostType.Fixed) return "$".concat(price);
    if (pricingType === ServiceCostType.Range) return "$".concat(price, " - $").concat(price);
    return "$".concat(price, "/h");
}
export function filterTemplates(serviceTemplates, searchTerm) {
    if (!searchTerm.trim()) {
        return serviceTemplates;
    }
    return serviceTemplates.filter((template)=>template.name.toLowerCase().includes(searchTerm.toLowerCase()));
}
